import styled, { css } from 'styled-components';

export const Container = styled.div<BadgeContainerProps>`
    align-items: center;
    background-color: ${({ $highlight }) => ($highlight ? '#467348' : '#385c3a')};
    border-radius: 5px;
    border: 0.5px solid ${({ $highlight }) => ($highlight ? '#F9C132' : '#507E53')};
    display: flex;
    gap: 4px;
    padding: 4px 8px;
    text-align: left;
    visibility: ${({ $hide }) => ($hide ? 'hidden' : 'visible')};

    ${({ $responsive }) =>
        $responsive &&
        css`
            @media (max-width: 960px) ${$responsive === 'full' ? 'or (1200px <= width < 1360px)' : ''} {
                display: block;
            }
        `}
`;
